export default {

  // Chat Search Query
  chatSearchQuery: "",

  // Stores All Contacts
  contacts: [],

  // Stores Chat Contacts
  chatContacts: [],

  // Stores Chat data(log)
  chats: {},

  // Stores Chat Active Now
  chatActives: 0,

  // Reply Message
  chatReplyMessage: null
}
